module.exports = __webpack_public_path__ + "img/Menu-07.8386c7e2.png";